import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getImageInfo = normalize.getImageInfo(function (args) {
  return swan.getImageInfo(args);
}, CONTAINER_NAME.BAIDU);
export default getImageInfo;